import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import type { QInputProps } from 'quasar'

interface Props extends QInputProps {
  modelValue: string,
  label: string,
  placeholder?: string,
  dense?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: undefined },
    label: { default: undefined },
    placeholder: { default: undefined },
    dense: { type: Boolean }
  },
  emits: ['update:model-value'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps(__props.dense ? _ctx.$inri.inputDense : _ctx.$inri.input, {
    "model-value": __props.modelValue,
    label: __props.label,
    placeholder: __props.placeholder,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event)))
  }), {
    append: _withCtx(() => [
      (__props.modelValue?.length)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "mdi-close",
            color: "grey-darker",
            class: "cursor-pointer",
            size: "18px",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('update:model-value', '')), ["stop"]))
          }))
        : (_openBlock(), _createBlock(_component_q_icon, {
            key: 1,
            name: "inri-search",
            color: "grey-dark",
            size: "18px"
          }))
    ]),
    _: 1
  }, 16, ["model-value", "label", "placeholder"]))
}
}

})